// @flow
import React, { Component, Fragment } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import CryptoJS from 'crypto-js';
import {BaseActions, CartActions, WishActions, CommonActions, SearchActions, UserActions} from 'store/actionCreators';
import { connect } from 'react-redux';
import type { State } from 'store';
import type { UserData } from 'store/modules/user';
import storage from 'lib/storage';
import NanoBar from 'components/common/NanoBar';
import throttle from 'lodash/throttle';
import { type ContextRouter, withRouter } from 'react-router-dom';

import { setup } from 'lib/progress';
import NotifyToastContainer from './NotifyToastContainer';

type Props = {
  user: ?UserData,
} & ContextRouter;

class Core extends Component<Props> {
  unlisten = null;

  constructor(props) {
    super(props);
    this.setWidth();
  }

  checkUser = async () => {
    const searchHistory = storage.get('searchHistory');
    if (!searchHistory) {
      storage.set('searchHistory', []);
      SearchActions.initializeSearchHistory([]);
    } else {
      SearchActions.initializeSearchHistory(searchHistory);
    }
    const storedUser = storage.get('__datasee_user__');
    if (!storedUser) {
      UserActions.processUser();
      await CartActions.getAsNonRegisteredCart({items: window.CacheBy.LocalCart.items});
      return;
    }
    await UserActions.setUser(storedUser);
    try {
      await UserActions.checkUser();
      await CartActions.getCart();
      await WishActions.getWish();
      setTimeout(() => {
        const { user } = this.props;
        let phone = '';
        if (user.mobile) {
          const cleanNumber = user.mobile.replace(/-/g, '');
          phone = `+82${cleanNumber}`;
          const e164Regex = /^\+[1-9]\d{1,14}$/;
          if (!e164Regex.test(phone)) {
            console.warn('전화번호가 E.164 형식에 맞지 않습니다:', phone);
            phone = '';
          }
        }
        const hash = CryptoJS.HmacSHA256(`${user.id}`, '208b18c115cae1b2f8f3528057362fd8e8506fb5').toString()
        window.Tawk_API.login({
          hash,
          userId: user.id,
          name: user.managerName || '',
          email: user.email,
          phone,
          companyName: user.displayName || '',
          bizNumber: user.bizNumber || '',
          grade: user.grade ? user.grade.name : '',
        }, (error) => {
          if (error) {
            console.error('Tawk API 로그인 오류:', error);
          } else {
            console.log('Tawk API 로그인 성공');
          }
        });
      }, 3000);
    } catch (e) {
      console.log('꺠짐', e.message);
      storage.remove('__datasee_user__');
    }
  };

  setWidth = () => {
    if (typeof window === 'undefined') return;
    BaseActions.setWidth(window.outerWidth);
  };

  onResize = throttle(() => {
    this.setWidth();
  }, 250);

  initialize = async () => {
    this.checkUser();
    window.addEventListener('resize', this.onResize);
  };

  gaDataLayer = location => {
    setTimeout(() => {
      if (window && window.dataLayer) {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'pageview',
          page: {
            path: location.pathname + location.search,
            search: location.search,
            title: document.title,
          },
        });
      }
      // if (window && window.ChannelIO) {
      //   window.ChannelIO('track', 'PageView');
      // }
    }, 0);
  };

  listenHistory = () => {
    const { history } = this.props;
    this.unlisten = history.listen((location, type) => {
      this.gaDataLayer(location);
      CommonActions.changeRoute({
        type,
        ...location,
      });
    });
  };

  componentDidMount() {
    const { location } = this.props;
    this.initialize();
    this.listenHistory();
    this.gaDataLayer(location);
    CommonActions.changeRoute({
      type: 'PUSH',
      ...location,
    });
    setup();
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  render() {
    return (
      <Fragment>
        {/* <FullscreenLoaderContainer /> */}
        <NanoBar />
        <NotifyToastContainer />
      </Fragment>
    );
  }
}

export default connect(
  ({ user }: State) => ({
    user: user.user,
  }),
  () => ({}),
)(withRouter(Core));



// WEBPACK FOOTER //
// ./src/containers/base/Core.js